import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Urbaniaforpunetokolhapur() {



    const cardData =
    {
        keyword: 'Urbania for Pune to Kolhapur On Rent',
        heading: 'Urbania on rent in pune: Urbania for Pune to Kolhapur On Rent',
        headingDescription: 'Urbania On Rent in Pune offers reliable and comfortable Urbania for Pune to Kolhapur On Rent services for families, corporate groups, tourists, and event travelers planning trips to Kolhapur. Our well-maintained Force Urbania fleet provides spacious seating, air-conditioned comfort, and smooth performance, making it ideal for long-distance travel, weekend getaways, corporate tours, and group sightseeing from Pune to Kolhapur. With professional chauffeurs, flexible one-way and round-trip rental options, and convenient doorstep pickup from major areas including Hinjewadi, Baner, Wakad, Kharadi, Hadapsar, Kothrud, Pimpri Chinchwad, and Pune Airport, we ensure a safe, punctual, and stress-free journey. Supported by 24/7 booking assistance, transparent pricing, and trusted service, Urbania On Rent in Pune stands out as the preferred choice for Urbania hire from Pune to Kolhapur.',

        top: 'Top Places to Visit in Kolhapur with Urbania on rent in pune',


    "topPlaces": [
  {
    "title": "Mahalaxmi Temple",
    "description": "The Mahalaxmi Temple, also known as the Ambabai Temple, is one of the Shakti Peethas and Kolhapur’s most revered spiritual landmarks. Built in the 7th century by the Chalukyas, it showcases intricate stone carvings, a sacred idol of Goddess Mahalaxmi, and a divine atmosphere that attracts devotees year-round. The temple complex remains a major cultural and religious center of Maharashtra."
  },
  {
    "title": "New Palace (Shahu Palace)",
    "description": "The New Palace is an architectural masterpiece built in black polished stone that served as the royal residence of Chhatrapati Shahu Maharaj. The palace houses the Shahaji Chhatrapati Museum, featuring a rich collection of royal artifacts, personal belongings, hunting trophies, paintings, and historical documents. Its blend of Jain and Hindu architectural styles adds to its grandeur."
  },
  {
    "title": "Rankala Lake",
    "description": "Rankala Lake is a scenic waterbody created during the reign of the Chalukya dynasty. Surrounded by gardens, walking paths, and street food stalls, the lake is a popular spot for evening strolls and boating. The serene atmosphere, along with the iconic Shalini Palace nearby, makes it a favorite recreational destination for tourists and locals."
  },
  {
    "title": "Panhala Fort",
    "description": "Panhala Fort is one of the largest and most historically significant forts in Maharashtra. Known for its association with Maharani Tarabai and Chhatrapati Shivaji Maharaj, the fort offers breathtaking valley views and architectural wonders like the Sajja Kothi and Andhar Bavadi. Its strategic location and rich Maratha history make it a major attraction near Kolhapur."
  },
  {
    "title": "Jyotiba Temple",
    "description": "Situated on a hill 17 km from Kolhapur, the Jyotiba Temple is a sacred Hindu pilgrimage site dedicated to Lord Jyotiba, believed to be an incarnation of Shiva. The temple becomes a sea of pink during the annual fairs, when devotees celebrate by throwing 'gulal'. Its unique rituals and hilltop location attract pilgrims and cultural enthusiasts."
  },
  {
    "title": "Shalini Palace",
    "description": "Shalini Palace is a beautiful lakeside palace built in 1931 using black stone and Italian marble. Surrounded by lush gardens and located on the shores of Rankala Lake, the palace once served as a royal residence and later a luxury hotel. Its Indo-European architecture, stained-glass windows, and peaceful ambience make it a striking heritage spot."
  },
  {
    "title": "Dajipur Wildlife Sanctuary",
    "description": "Located on the Kolhapur–Belgaum road, the Dajipur Wildlife Sanctuary—also known as the Bison Sanctuary—is home to Indian bison (gaur), deer, leopards, and diverse bird species. Nestled amidst the Sahyadri mountains, it offers jungle safaris, trekking trails, and scenic viewpoints perfect for nature lovers and adventure seekers."
  },
  {
    "title": "Bhavani Mandap",
    "description": "Bhavani Mandap is a historical monument built during the reign of Chhatrapati Shahu Maharaj and served as a royal court and administrative center. The structure includes carved pillars, spacious halls, ancient weapons, and a shrine dedicated to Goddess Bhavani. It stands as a reminder of Kolhapur’s glorious Maratha heritage."
  },
  {
    "title": "Chandoli National Park",
    "description": "Chandoli National Park, situated near Kolhapur, is known for its rich biodiversity including leopards, tigers, and a variety of flora. The park features scenic trekking trails, waterfalls, and viewpoints offering panoramic views of the Western Ghats. It is an ideal destination for nature lovers, wildlife enthusiasts, and adventure seekers."
  },
  {
    "title": "Ambabai Mandir",
    "description": "Ambabai Mandir is another sacred temple dedicated to Goddess Mahalaxmi within Kolhapur city. The temple is famous for its unique rituals, spiritual significance, and intricate stone carvings. Devotees from across Maharashtra and India visit to seek blessings, making it a vibrant spiritual hub in the region."
  }
],



"services": [
    {
      "name": "Pune to Kolhapur Urbania on Rent",
      "description": "Pune to Kolhapur Urbania on Rent provides well-maintained, comfortable vehicles for long-distance travel between Pune and Kolhapur. Ideal for families, groups, and corporate travelers, the service ensures spacious seating, professional chauffeurs, ample luggage space, and a safe, stress-free journey while enjoying highway comfort and punctuality."
    },
    {
      "name": "Urbania Hire Pune to Kolhapur",
      "description": "Urbania Hire Pune to Kolhapur offers reliable and convenient intercity vehicle rental options. Perfect for group travel, corporate trips, and family outings, this service emphasizes timely pickups, smooth travel, trained chauffeurs, and a comfortable journey to Kolhapur without any hassle or delays."
    },
    {
      "name": "Urbania Bus Rental Pune to Kolhapur",
      "description": "Urbania Bus Rental Pune to Kolhapur provides spacious buses suitable for large groups, corporate tours, and family trips. With ample seating, professional chauffeurs, and safety features, these buses ensure a comfortable, organized, and enjoyable journey over long distances between Pune and Kolhapur."
    },
    {
      "name": "Urbania AC Bus Pune to Kolhapur",
      "description": "Urbania AC Bus Pune to Kolhapur offers fully air-conditioned buses for maximum comfort during intercity travel. Ideal for families, corporate groups, and tourists, these buses feature climate control, spacious seating, luggage storage, and experienced drivers to make the long journey from Pune to Kolhapur smooth and relaxing."
    },
    {
      "name": "Pune Kolhapur Urbania One Way Hire",
      "description": "Pune Kolhapur Urbania One Way Hire provides flexible travel options for individuals, families, and corporate groups. Vehicles are spacious, well-maintained, and driven by professional chauffeurs, ensuring a convenient, safe, and stress-free journey from Pune to Kolhapur without worrying about return travel."
    },
    {
      "name": "Pune Kolhapur Urbania Round Trip Hire",
      "description": "Pune Kolhapur Urbania Round Trip Hire delivers reliable round-trip transportation solutions. With clean, well-maintained vehicles, experienced chauffeurs, and punctual service, travelers can enjoy a comfortable journey to Kolhapur and back to Pune, making it ideal for family outings, group trips, and corporate travel."
    },
    {
      "name": "Corporate Urbania Pune to Kolhapur",
      "description": "Corporate Urbania Pune to Kolhapur provides professional transportation solutions for business trips, corporate retreats, and conferences. Vehicles are equipped with executive comfort features, spacious seating, and experienced chauffeurs, ensuring a seamless and productive travel experience for corporate teams traveling between Pune and Kolhapur."
    },
    {
      "name": "Family Tour Urbania Pune to Kolhapur",
      "description": "Family Tour Urbania Pune to Kolhapur offers safe, comfortable, and spacious vehicles for family vacations and group outings. With courteous drivers, ample luggage space, and well-maintained interiors, families can enjoy a stress-free journey while focusing on sightseeing, cultural visits, and leisure activities in Kolhapur."
    },
    {
      "name": "Luxury Urbania Pune to Kolhapur",
      "description": "Luxury Urbania Pune to Kolhapur provides high-end air-conditioned vehicles with plush interiors and superior ride quality for VIPs, executives, and travelers seeking premium comfort. With professional chauffeurs, smooth rides, and attention to detail, this service ensures a luxurious long-distance travel experience between Pune and Kolhapur."
    },
    {
      "name": "Affordable Urbania Pune to Kolhapur",
      "description": "Affordable Urbania Pune to Kolhapur delivers cost-effective intercity transportation without compromising comfort or reliability. Ideal for budget-conscious travelers, families, and small groups, the service provides safe, clean vehicles and professional chauffeurs for a comfortable and dependable journey."
    },
    {
      "name": "Chauffeur Driven Urbania Pune to Kolhapur",
      "description": "Chauffeur Driven Urbania Pune to Kolhapur offers stress-free travel with verified and experienced drivers. Vehicles are spacious, well-maintained, and suitable for long-distance trips, allowing travelers to enjoy a comfortable, safe, and convenient journey between Pune and Kolhapur without worrying about navigation or driving."
    },
    {
      "name": "Pune Kolhapur Urbania Travel Service",
      "description": "Pune Kolhapur Urbania Travel Service provides end-to-end transportation solutions for all types of travelers. From reliable vehicles and professional chauffeurs to timely pickups and luggage assistance, this service ensures a smooth, comfortable, and enjoyable journey from Pune to Kolhapur for leisure, corporate, and group trips."
    },
    {
      "name": "Best Urbania Hire Pune to Kolhapur",
      "description": "Best Urbania Hire Pune to Kolhapur delivers top-rated intercity travel services with a focus on reliability, comfort, and customer satisfaction. Suitable for families, corporate teams, and group travelers, it ensures smooth, safe, and punctual journeys, making it the preferred choice for Pune to Kolhapur travel."
    },
    {
      "name": "Pune to Kolhapur Urbania Booking",
      "description": "Pune to Kolhapur Urbania Booking allows easy and convenient reservation of Urbania vehicles for one-way or round-trip journeys. Travelers can select from various vehicle options to ensure a comfortable, safe, and hassle-free trip between Pune and Kolhapur with professional chauffeur services included."
    },
    {
      "name": "Urbania for Outstation Trip Pune to Kolhapur",
      "description": "Urbania for Outstation Trip Pune to Kolhapur provides reliable long-distance travel solutions with well-maintained vehicles and experienced chauffeurs. Perfect for family trips, corporate travel, and group outings, this service emphasizes safety, comfort, punctuality, and an overall stress-free journey between Pune and Kolhapur."
    }
  ],
  "tableData": [
    ["Pune to Kolhapur Urbania on Rent", "Urbania Hire Pune to Kolhapur"],
    ["Urbania Bus Rental Pune to Kolhapur", "Urbania AC Bus Pune to Kolhapur"],
    ["Pune Kolhapur Urbania One Way Hire", "Pune Kolhapur Urbania Round Trip Hire"],
    ["Corporate Urbania Pune to Kolhapur", "Family Tour Urbania Pune to Kolhapur"],
    ["Luxury Urbania Pune to Kolhapur", "Affordable Urbania Pune to Kolhapur"],
    ["Chauffeur Driven Urbania Pune to Kolhapur", "Pune Kolhapur Urbania Travel Service"],
    ["Best Urbania Hire Pune to Kolhapur", "Pune to Kolhapur Urbania Booking"],
    ["Urbania for Outstation Trip Pune to Kolhapur", ""]
  ],





"whychoose": [
    {
        "WhyChooseheading": "Reliable Urbania for Pune to Kolhapur On Rent",
        "WhyChoosedescription": "Urbania for Pune to Kolhapur On Rent is perfect for comfortable and spacious group travel, ideal for family trips, corporate travel, weddings, and outstation journeys."
    },
    {
        "WhyChooseheading": "Spacious and Comfortable Force Urbania Vehicles",
        "WhyChoosedescription": "Urbania for Pune to Kolhapur On Rent provides well-maintained Force Urbania vehicles with ample seating and luggage space, ensuring a smooth and hassle-free journey."
    },
    {
        "WhyChooseheading": "Experienced and Professional Drivers",
        "WhyChoosedescription": "Urbania for Pune to Kolhapur On Rent comes with skilled drivers familiar with Pune-Kolhapur routes and highways, ensuring safe, timely, and stress-free travel."
    },
    {
        "WhyChooseheading": "Transparent and Affordable Pricing",
        "WhyChoosedescription": "Choose Urbania for Pune to Kolhapur On Rent for competitive rates with no hidden charges, making outstation group travel budget-friendly and reliable."
    },
    {
        "WhyChooseheading": "24/7 Booking and Customer Support",
        "WhyChoosedescription": "Urbania for Pune to Kolhapur On Rent provides round-the-clock assistance for bookings, inquiries, and last-minute travel requirements."
    },
    {
        "WhyChooseheading": "Flexible Rental Packages",
        "WhyChoosedescription": "Urbania for Pune to Kolhapur On Rent is available for one-way trips, round trips, corporate travel, wedding transportation, and customized packages."
    },
    {
        "WhyChooseheading": "Clean, Sanitized, and Well-Maintained Vehicles",
        "WhyChoosedescription": "All Urbania vehicles for Pune to Kolhapur trips are regularly cleaned, sanitized, and serviced to ensure a safe and comfortable journey."
    },
    {
        "WhyChooseheading": "Punctual and Reliable Service",
        "WhyChoosedescription": "Urbania for Pune to Kolhapur On Rent guarantees timely pickups and dependable service, ensuring stress-free and smooth travel."
    }
]
}

const faqData = [
    {
        question: 'Is Urbania for Pune to Kolhapur On Rent available for local travel as well?',
        answer: 'Yes, Urbania for Pune to Kolhapur On Rent can also be booked for local travel within Pune or nearby areas, offering a comfortable and spacious ride.',
    },
    {
        question: 'How can I book Urbania for Pune to Kolhapur On Rent?',
        answer: 'You can book Urbania for Pune to Kolhapur On Rent via phone, WhatsApp, or online for quick and hassle-free reservations.',
    },
    {
        question: 'Why choose Urbania for Pune to Kolhapur On Rent for group travel?',
        answer: 'Urbania for Pune to Kolhapur On Rent provides ample seating, luggage space, and a smooth ride, making it ideal for family, corporate, and group travel.',
    },
    {
        question: 'Is Urbania for Pune to Kolhapur On Rent suitable for corporate and event travel?',
        answer: 'Yes, it is perfect for corporate trips, airport transfers, weddings, events, and one-way or round-trip travel to Kolhapur.',
    },
    {
        question: 'Are drivers experienced with Urbania for Pune to Kolhapur On Rent?',
        answer: 'Yes, all drivers are professionally trained, licensed, and experienced in handling Force Urbania vehicles to ensure safe and comfortable travel.',
    },
    {
        question: 'Can I customize pickup and drop-off locations with Urbania for Pune to Kolhapur On Rent?',
        answer: 'Absolutely. Urbania for Pune to Kolhapur On Rent allows flexible pickup and drop-off across Pune and Kolhapur.',
    },
    {
        question: 'Is Urbania for Pune to Kolhapur On Rent available 24x7?',
        answer: 'Yes, Urbania for Pune to Kolhapur On Rent operates 24x7 to accommodate travel needs at any time.',
    },
    {
        question: 'Are hygiene and safety standards maintained for Urbania for Pune to Kolhapur On Rent?',
        answer: 'Yes, all vehicles are regularly cleaned, sanitized, and maintained with strict safety protocols for every trip.',
    },
    {
        question: 'What payment options are available for Urbania for Pune to Kolhapur On Rent?',
        answer: 'Urbania for Pune to Kolhapur On Rent accepts UPI, digital wallets, credit/debit cards, bank transfers, and corporate billing options.',
    },
    {
        question: 'Is customer support available during the journey?',
        answer: 'Yes, dedicated customer support is available throughout the journey to ensure a smooth and stress-free experience.',
    },
];

const testimonials = [
    {
        id: 1,
        name: 'Mr. Ashok Deshmukh',
        feedback: 'We booked Urbania for Pune to Kolhapur On Rent for a family trip. The vehicle was spacious, comfortable, and very reliable. Excellent service!',
        rating: 5,
    },
    {
        id: 2,
        name: 'Ms. Neha Patil',
        feedback: 'Urbania for Pune to Kolhapur On Rent provided seamless service for our corporate travel. The driver was professional and punctual. Highly recommended!',
        rating: 5,
    },
];





























































    const Images = [
        { place: "/images/keyword/1.jpg", text: "Urbania On Rent Pune", link: "urbania-on-rent-pune" },
        { place: "/images/keyword/2.jpg", text: "Urbania on Rent in Pimpri Chinchwad", link: "urbania-on-rent-in-pimpri-chinchwad" },
        { place: "/images/keyword/3.jpg", text: "Urbania Hire for Corporate Events in Pune", link: "urbania-hire-for-corporate-events-in-pune" },
        { place: "/images/keyword/4.jpg", text: "17 Seater Urbania on Rent in Pune", link: "17-seater-urbania-on-rent-in-pune" },
        { place: "/images/keyword/5.jpg", text: "14 Seater Urbania on Rent in Pune", link: "14-seater-urbania-on-rent-in-pune" },
        { place: "/images/keyword/6.jpg", text: "Urbania on Rent in Kharadi", link: "urbania-on-rent-in-kharadi" },
        { place: "/images/keyword/7.jpg", text: "Urbania on Rent in Hadapsar", link: "urbania-on-rent-in-hadapsar" },
        { place: "/images/keyword/8.jpg", text: "Urbania on Rent in Kothrud", link: "urbania-on-rent-in-kothrud" },
        { place: "/images/keyword/9.jpg", text: "Urbania On Rent in Bibwewadi", link: "urbania-on-rent-in-bibwewadi" },
        { place: "/images/keyword/10.jpg", text: "Urbania on Rent in Koregaon Park", link: "urbania-on-rent-in-koregaon-park" },
        { place: "/images/keyword/11.jpg", text: "Urbania On Rent in Kalyani Nagar", link: "urbania-on-rent-in-kalyani-nagar" },
        { place: "/images/keyword/12.jpg", text: "Urbania On Rent in Mundhwa Pune", link: "urbania-on-rent-in-mundhwa-pune" },
        { place: "/images/keyword/13.jpg", text: "Urbania Bus On Rent in Baner", link: "urbania-bus-on-rent-in-baner" },
        { place: "/images/keyword/14.jpg", text: "Urbania AC Bus On Rent in Aundh", link: "urbania-ac-bus-on-rent-in-aundh" },
        { place: "/images/keyword/15.jpg", text: "Urbania Bus On Rent in Hinjewadi", link: "urbania-bus-on-rent-in-hinjewadi" },
        { place: "/images/keyword/16.jpg", text: "Urbania on Rent in Bhosari", link: "urbania-on-rent-in-bhosari" },
        { place: "/images/keyword/17.jpg", text: "Urbania on Rent in Pune Station", link: "urbania-on-rent-in-pune-station" },
        { place: "/images/keyword/18.jpg", text: "Urbania On Rent in Chakan", link: "urbania-on-rent-in-chakan" },
        { place: "/images/keyword/19.jpg", text: "Urbania On Rent in Moshi", link: "urbania-on-rent-in-moshi" },
        { place: "/images/keyword/20.jpg", text: "Urbania On Rent in Charholi Budruk", link: "urbania-on-rent-in-charholi-budruk" },
        { place: "/images/keyword/21.jpg", text: "Urbania On Rent in Nigdi Pradhikaran", link: "urbania-on-rent-in-nigdi-pradhikaran" },
        { place: "/images/keyword/22.jpg", text: "Urbania On Rent in Lohegaon", link: "urbania-on-rent-in-lohegaon" },
        { place: "/images/keyword/23.jpg", text: "Urbania On Rent in Wagholi", link: "urbania-on-rent-in-wagholi" },
        { place: "/images/keyword/24.jpg", text: "Urbania Rental Service in Pune", link: "urbania-rental-service-in-pune" },
        { place: "/images/keyword/25.jpg", text: "Best Urbania on Rent in Pune", link: "best-urbania-on-rent-in-pune" }
    ];











const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Urbania for Pune to Kolhapur On Rent",
  "image": "https://urbaniaonrentpune.in/assets/images/urbania-pune-to-kolhapur.jpg",
  "description": "Urbania for Pune to Kolhapur On Rent offers AC and non-AC Urbania bus rental services for one-way and round-trip travel. Perfect for family tours, corporate trips, luxury travel, and outstation trips. Chauffeur-driven Urbania buses ensure comfortable, safe, and affordable journeys from Pune to Kolhapur.",
  "brand": {
    "@type": "Brand",
    "name": "Urbania on Rent in Pune"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "ratingCount": "950",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "12000",
    "availability": "https://schema.org/InStock",
    "url": "https://urbaniaonrentpune.in/urbania-pune-to-kolhapur-on-rent"
  }
};








    return (
        <div>
<Helmet>
  <title>
    Call:+91 9209423113 | Urbania for Pune to Kolhapur On Rent | AC & Luxury Urbania Bus Rental 
  </title>

  <meta
    name="description"
    content="Book Urbania for Pune to Kolhapur On Rent for one-way or round-trip travel. AC and non-AC Urbania buses for family tours, corporate trips, luxury travel, and outstation trips. Chauffeur-driven service ensures safe and comfortable journeys."
  />

  <meta
    name="keywords"
    content="Pune to Kolhapur Urbania on Rent, Urbania Hire Pune to Kolhapur, Urbania Bus Rental Pune to Kolhapur, Urbania AC Bus Pune to Kolhapur, Pune Kolhapur Urbania One Way Hire, Pune Kolhapur Urbania Round Trip Hire, Corporate Urbania Pune to Kolhapur, Family Tour Urbania Pune to Kolhapur, Luxury Urbania Pune to Kolhapur, Affordable Urbania Pune to Kolhapur, Chauffeur Driven Urbania Pune to Kolhapur, Pune Kolhapur Urbania Travel Service, Best Urbania Hire Pune to Kolhapur, Pune to Kolhapur Urbania Booking, Urbania for Outstation Trip Pune to Kolhapur"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
            <div
                className="breadcumb-wrapper"
                
                data-overlay="black"
                data-opacity="3"
            >
                <div className="container">
                    <div className="breadcumb-content text-center">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>





            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/35.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">
                                <p className="sectionLead">{cardData.top}</p>

                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>
                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>



                            <div className="shambhu-services">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="sh-service-card">

                                        <div className="sh-service-left">
                                            <div className="sh-service-icon">
                                                🚌
                                            </div>
                                        </div>

                                        <div className="sh-service-content">
                                            <h4 className="sh-service-title">{service.name}</h4>
                                            <p className="sh-service-desc">{service.description}</p>
                                        </div>

                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title">
                                    Why Choose <span>Urbania On rent in Pune </span>
                                </h2>

                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Urbania on rent in Pune </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919209423113" className="pc-call">+91 9209423113</a>
                                            <a href="tel:+917620411277 " className="pc-call">+91 7620411277 </a>
                                            <a href="tel:+919284718314" className="pc-call">+91 9284718314</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919209423113"
                                                target="_blank" rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp me-1"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919209423113" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@urbaniaonrentpune.in" className="pc-email">
                                            booking@urbaniaonrentpune.in
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-house-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Urbania on rent in pune</strong><br />
                                            Saket Tata Power CHS, Swami Samarth Marg,
                                            Juhu Nagar, Sector-16, Vashi, Navi Mumbai,
                                            Maharashtra India - 400703
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Urbaniaforpunetokolhapur;